/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UserShipToAddress {
  /**
   * Address string
   */
  address?: string;
  /**
   * First name
   */
  first_name?: string;
  /**
   * Address ID
   */
  id?: string;
  /**
   * Last name
   */
  last_name?: string;
  /**
   * Phone number
   */
  phone?: string;
}
